import React from "react";
import { Skeleton } from "@common/skeleton";

import { Props } from "./types";
import styles from "./styles.scss";

function Zone(_: Props) {
  return (
    <div className={styles.zone}>
      <div className={styles.header}>
        <div className={styles.name}>
          <Skeleton className={styles.avatar} />
          <Skeleton className={styles.nameLoader} />
        </div>
      </div>
    </div>
  );
}

export { Zone };
